import { useNavigate } from "react-router-dom";
import { useFeedbackPage } from "../../api/api-hooks";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTanstackTableUi from "../../common/ReactTanstackTableUi";
import { FaEye } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import useCommonStore from "../../store/CommonStore";
import {
  filterDataByDate,
  getDateRangeFromSelectedValue,
} from "../../common/Constants";
import { useMemo } from "react";
// import { formatDateTimeAndYear } from "../../utils/date-utils";

function prepareColumns(columnHelper: any, handleActions: any) {
  return [
    columnHelper.accessor((row: any) => row.username, {
      id: "username",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base truncate w-full max-w-xs">
              {original?.username || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Username</div>,
    }),
    columnHelper.accessor((row: any) => row.prompt_text, {
      id: "prompt_text",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base truncate w-full max-w-xs">
              {original?.prompt_text || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Message</div>,
    }),
    columnHelper.accessor((row: any) => row.llm, {
      id: "llm",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {original?.llm || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>LLM</div>,
    }),
    columnHelper.accessor((row: any) => row.reaction, {
      id: "reaction",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {original?.reaction || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Reaction</div>,
    }),
    columnHelper.accessor((row: any) => row.custom_feedback, {
      id: "custom_feedback",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {original?.custom_feedback ||
                original?.selected_feedback[0] ||
                "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Reaction</div>,
    }),
    columnHelper.accessor((row: any) => row.actions, {
      id: "Actions",
      cell: (info: any) => {
        const row = info.row;
        // const original = row?.original;
        const fetchId = row?.original?.id;

        return (
          <div className="flex items-center relative">
            <FaEye
              className="absolute left-1/2 transform -translate-x-1/2 text-grey-500 cursor-pointer"
              onClick={() => handleActions("view", fetchId)}
              title="View"
            />

            {/* <FaTrashAlt
    className="ml-auto text-red-500 cursor-pointer"
    onClick={() => console.log("delete", original?.id)}
    title="Delete"
  /> */}
          </div>
        );
      },
      header: () => <div>Actions</div>,
    }),
  ];
}

function FeedbackListTable() {
  const { selectedValue, selectedFeedback } = useCommonStore();

  const dateRange = getDateRangeFromSelectedValue(selectedValue);

  // const { startDate, endDate } = dateRange!;

  const { pageIndex, pageSize, getPaginationInfo } = usePagination();
  //   const { data: feedback, isLoading: isFeedbackLoading } = useFeedback();

  const isAllData = dateRange?.isAllData ?? false;
  const startDate = isAllData ? undefined : dateRange?.startDate ?? "";
  const endDate = isAllData ? undefined : dateRange?.endDate ?? "";

  const { data: feedbacks, isLoading: isFeedbackLoading } = useFeedbackPage(
    pageIndex + 1,
    pageSize,
    startDate,
    endDate,
    isAllData,
    selectedFeedback?.value
  );

  const apiData = useMemo(() => {
    return Array.isArray(feedbacks?.items) ? feedbacks?.items : [];
  }, [feedbacks]);

  const columnHelper = createColumnHelper();

  const columns = prepareColumns(columnHelper, handleActions);

  const navigate = useNavigate();

  const paginationInfo = getPaginationInfo(feedbacks);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { filteredData } = useMemo(() => {
    return filterDataByDate(apiData, selectedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiData, selectedValue]);

  function handleActions(fetchType: string, fetchId: string) {
    if (!isFeedbackLoading && fetchType === "view") {
      navigate(`/feedback/${fetchId}`);
    }
    if (!isFeedbackLoading && fetchType === "delete") {
      // console.log("delete");
    }
  }

  // if (isFeedbackLoading) {
  //   return <Loader />;
  // }

  return (
    <div className="md:p-10 p-3">
      <ReactTanstackTableUi
        // data={apiData}
        // columns={columns}
        // pagination={apiData?.length > 10}
        // noDataMessage="Feedback"
        // tableTitle="Feedback List"

        data={apiData}
        columns={columns}
        // pagination={apiData?.length > 10}
        noDataMessage="Feedbacks"
        tableTitle="Feedbacks"
        disableRowHeight={true}
        pagination={true}
        externalPagination={paginationInfo}
        isLoading={isFeedbackLoading}
        isFeedbackDropdown={true}
      />
    </div>
  );
}

function Feedback() {
  return (
    <div className=" flex flex-col gap-6 ">
      <div>
        <FeedbackListTable />
      </div>
    </div>
  );
}

export default Feedback;
